"use strict";
var appn;
(function (appn) {
    var notifications;
    (function (notifications) {
        notifications.notificationPoll = 5500;
        notifications.notificationTimer = null;
        function showNotificationsDialog(launchBtn) {
            const url = launchBtn.data('notifications-launch');
            if (!url)
                return;
            appn.iframe.openModal({ url: url })
                .then(function ($modal) {
                $modal.on('hidden.bs.modal', function () {
                    updateNotificationTotal();
                });
            });
        }
        notifications.showNotificationsDialog = showNotificationsDialog;
        function updateNotificationTotal(isBackingOff) {
            const notificationETag = window.localStorage.getItem('notificationETag');
            ensureClickHandler();
            appn.ajax.post({
                url: appn.urls.notifications.total,
                data: { etag: notificationETag },
                dataType: 'json',
                done: function (data) {
                    const notificationETag = data.ETagSafe;
                    window.localStorage.setItem('notificationETag', notificationETag);
                    const $noticeDiv = $('.nav-notification');
                    const $noticeDot = $('.noticeDot');
                    if (data.Total === 0) {
                        $noticeDiv.hide();
                        $noticeDot.hide();
                        return;
                    }
                    $noticeDot.show();
                    $noticeDiv.show();
                    const $noticeBell = $('.notice-bell');
                    let css = 'info';
                    if (data.HasError)
                        css = 'danger';
                    else if (data.HasReady || data.HasComplete)
                        css = 'success';
                    else if (data.HasInProgress)
                        css = 'purple';
                    else if (data.HasPending)
                        css = 'warning';
                    else if (data.HasInformation)
                        css = 'info';
                    $noticeBell
                        .removeClass('fa-duotone-brand-info')
                        .removeClass('fa-duotone-brand-danger')
                        .removeClass('fa-duotone-brand-success')
                        .removeClass('fa-duotone-brand-warning')
                        .removeClass('fa-duotone-brand-purple')
                        .addClass('fa-duotone-brand-' + css);
                    $noticeDot
                        .removeClass('bg-info')
                        .removeClass('bg-danger')
                        .removeClass('bg-success')
                        .removeClass('bg-warning')
                        .removeClass('bg-purple')
                        .addClass('bg-' + css);
                    if (data.SuccessCount > 0)
                        $('.notice-badge.badge-success').text(data.SuccessCount).fadeIn();
                    else
                        $('.notice-badge.badge-success').text('0').css('display', 'none');
                    if (data.InfoCount > 0)
                        $('.notice-badge.badge-info').text(data.InfoCount).fadeIn();
                    else
                        $('.notice-badge.badge-info').text('0').css('display', 'none');
                    if (data.InProgressCount > 0)
                        $('.notice-badge.badge-purple').text(data.InProgressCount).fadeIn();
                    else
                        $('.notice-badge.badge-purple').text('0').css('display', 'none');
                    if (data.PendingCount > 0 && data.InProgressCount === 0)
                        $('.notice-badge.badge-warning').text(data.PendingCount).fadeIn();
                    else
                        $('.notice-badge.badge-warning').text('0').css('display', 'none');
                    if (data.ErrorCount > 0)
                        $('.notice-badge.badge-danger').text(data.ErrorCount).fadeIn();
                    else
                        $('.notice-badge.badge-danger').text('0').css('display', 'none');
                    if (data.HasNew)
                        setTimeout(function () {
                            $noticeBell.removeClass('shake-lr');
                            $noticeDiv.find('.notice-badge-mini').removeClass('heartbeat');
                            setTimeout(function () {
                                $noticeBell.addClass('shake-lr');
                                $noticeDiv.find('.notice-badge-mini').addClass('heartbeat');
                            }, 100);
                            if (data.DownloadLink)
                                appn.toast.notify('success', `Your Download is Ready. <a href="${data.DownloadLink}" target="_blank">Click here to Download</button>`);
                        }, 1000);
                    if (notifications.notificationTimer !== null)
                        window.clearTimeout(notifications.notificationTimer);
                    if (isBackingOff)
                        notifications.notificationPoll += notifications.notificationPoll < 7000 ? 1500 : 10000;
                    else
                        notifications.notificationPoll = 1500;
                    notifications.notificationTimer = setTimeout(function () {
                        updateNotificationTotal(true);
                    }, notifications.notificationPoll);
                    ensureClickHandler();
                },
                fail: function () {
                    $('.nav-notification').hide();
                }
            });
        }
        notifications.updateNotificationTotal = updateNotificationTotal;
        function hideNotificationIcon() {
            const $noticeDiv = $('.nav-notification');
            $noticeDiv.hide();
            if (notifications.notificationTimer !== null)
                window.clearTimeout(notifications.notificationTimer);
        }
        notifications.hideNotificationIcon = hideNotificationIcon;
        function deleteNotificationsCsv(itemIdsCsv, onAlwaysCallback) {
            appn.ajax.post({
                url: appn.urls.notifications.delete,
                data: { itemIdsCsv: itemIdsCsv },
                always: function () {
                    updateNotificationTotal(true);
                    if (onAlwaysCallback)
                        onAlwaysCallback();
                }
            });
        }
        notifications.deleteNotificationsCsv = deleteNotificationsCsv;
        function rescheduleNotificationsCsv(itemIdsCsv, onAlwaysCallback) {
            appn.ajax.post({
                url: appn.urls.notifications.reschedule,
                data: { itemIdsCsv: itemIdsCsv },
                always: function () {
                    updateNotificationTotal(true);
                    if (onAlwaysCallback)
                        onAlwaysCallback();
                }
            });
        }
        notifications.rescheduleNotificationsCsv = rescheduleNotificationsCsv;
        function ensureClickHandler() {
            $('[data-notifications-launch]').off().on('click', function (event) {
                event.preventDefault();
                showNotificationsDialog($(this));
            });
        }
    })(notifications = appn.notifications || (appn.notifications = {}));
})(appn || (appn = {}));
